import { render, staticRenderFns } from "./StockProducts.vue?vue&type=template&id=1b611d28&"
import script from "./StockProducts.vue?vue&type=script&lang=js&"
export * from "./StockProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports